import { Files } from '../../lib/constants/files'
import { DpaeAcknowledgmentReceiptInput } from '../../lib/types/models/mission-tracking/mission-tracking-input'
import { uploadFile } from '../../lib/utils/functions/file.functions'
import { API } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function uploadDpaeAcknowledgmentReceipt(data: DpaeAcknowledgmentReceiptInput) {
  const file = await uploadFile(Files.TEMPORARY_FILES, data.file)

  return restApiClient.url(API.missionTrackings.uploadDpaeAcknowledgmentReceipt.url).post({ file })
}
